"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RawLoadingIndicator = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Spinner = _interopRequireDefault(require("@concur/nui-widgets/lib/Spinner/Spinner"));
var _nuiIntlRuntime = require("@concur/nui-intl-runtime");
var _excluded = ["isLoaded", "children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var RawLoadingIndicator = exports.RawLoadingIndicator = function RawLoadingIndicator(_ref) {
  var isLoaded = _ref.isLoaded,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var formatter = props.formatter;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Spinner.default, {
    visible: !isLoaded,
    size: "lg",
    id: "spinner",
    type: "block",
    message: formatter.formattedMessage('Loading')
  }), isLoaded && children);
};
RawLoadingIndicator.propTypes = {
  isLoaded: _propTypes.default.bool.isRequired,
  children: _propTypes.default.any
};
var _default = exports.default = (0, _nuiIntlRuntime.withFormatter)(RawLoadingIndicator);